export enum UserActivityEventType {
    ADS_CLIENTS_SAVE = 'ADS_CLIENTS_SAVE',
    ADS_CLIENTS_DELETE = 'ADS_CLIENTS_DELETE',
    ADS_CONTAINERS_SAVE = 'ADS_CONTAINERS_SAVE',
    ADS_CONTAINERS_TOGGLE_DISABLE = 'ADS_CONTAINERS_TOGGLE_DISABLE',
    ADS_CONTAINERS_DELETE = 'ADS_CONTAINERS_DELETE',
    ADS_FILES_UPLOAD = 'ADS_FILES_UPLOAD',
    ADS_FILES_DELETE = 'ADS_FILES_DELETE',
    ADS_PLAYLISTS_SAVE = 'ADS_PLAYLISTS_SAVE',
    ADS_PLAYLISTS_UPLOAD = 'ADS_PLAYLISTS_UPLOAD',
    ADS_PLAYLISTS_DELETE = 'ADS_PLAYLISTS_DELETE',
    ADS_VEHICLE_GROUPS_SAVE = 'ADS_VEHICLE_GROUPS_SAVE',
    ADS_VEHICLE_GROUPS_DELETE = 'ADS_VEHICLE_GROUPS_DELETE',
    ADS_ZONES_SAVE = 'ADS_ZONES_SAVE',
    ADS_ZONES_DELETE = 'ADS_ZONES_DELETE',
    CARRIERS_UPDATE = 'CARRIERS_UPDATE',
    CHART_FETCH = 'CHART_FETCH',
    DEPARTURE_ASSIGNMENT_SUMMARY = 'DEPARTURE_ASSIGNMENT_SUMMARY',
    DEVICE_DISABLE = 'DEVICE_DISABLE',
    FIELD_ADD = 'FIELD_ADD',
    FIELD_REMOVE = 'FIELD_REMOVE',
    FIELD_UPDATE = 'FIELD_UPDATE',
    GROUP_ADD = 'GROUP_ADD',
    GROUP_FETCH_LIST = 'GROUP_FETCH_LIST',
    GROUP_REMOVE = 'GROUP_REMOVE',
    GROUP_UPDATE = 'GROUP_UPDATE',
    MESSAGE_ADD = 'MESSAGE_ADD',
    MESSAGE_REMOVE = 'MESSAGE_REMOVE',
    PASSENGER_STATISTICS_CREATE = 'PASSENGER_STATISTICS_CREATE',
    POLYLINE_REMOVE = 'POLYLINE_REMOVE',
    SETTING_REMOVE_FOR_GROUP = 'SETTING_REMOVE_FOR_GROUP',
    SETTING_UPDATE_FOR_ADMIN = 'SETTING_UPDATE_FOR_ADMIN',
    SETTING_UPDATE_FOR_GROUP = 'SETTING_UPDATE_FOR_GROUP',
    STOP_PILES_REPORT_EXPORT = 'STOP_PILES_REPORT_EXPORT',
    STOP_PILES_REPORT_FETCH = 'STOP_PILES_REPORT_FETCH',
    STOP_PILES_REPORT_SEGMENT_TIME = 'STOP_PILES_REPORT_SEGMENT_TIME',
    STOP_PILES_REPORT_SUMMARY = 'STOP_PILES_REPORT_SUMMARY',
    STOP_PILES_UPDATE = 'STOP_PILES_UPDATE',
    TEAM_ASSIGNMENT_CIRCULAR_UPDATE = 'TEAM_ASSIGNMENT_CIRCULAR_UPDATE',
    TEAM_ASSIGNMENT_UPDATE = 'TEAM_ASSIGNMENT_UPDATE',
    USER_CREATE = 'USER_CREATE',
    USER_FETCH_LIST = 'USER_FETCH_LIST',
    USER_PASSWORD_CHANGED = 'USER_PASSWORD_CHANGED',
    USER_REMOVE = 'USER_REMOVE',
    USER_UPDATE = 'USER_UPDATE',
    USER_UPDATE_ROLES = 'USER_UPDATE_ROLES',
    VEHICLE_ADD = 'VEHICLE_ADD',
    VEHICLE_CONFIGURATION_UPDATE = 'VEHICLE_CONFIGURATION_UPDATE',
    VEHICLE_DISABLE = 'VEHICLE_DISABLE',
    VEHICLE_PROPERTIES_REMOVE = 'VEHICLE_PROPERTIES_REMOVE',
    VEHICLE_PROPERTIES_UPDATE = 'VEHICLE_PROPERTIES_UPDATE',
    VEHICLE_PROPERTY_UPDATE = 'VEHICLE_PROPERTY_UPDATE',
    VEHICLE_REPORT_DISTANCE = 'VEHICLE_REPORT_DISTANCE',
    VEHICLE_REPORT_HISTORICAL_DATA = 'VEHICLE_REPORT_HISTORICAL_DATA',
    VEHICLE_REPORT_HISTORICAL_DATA_CSV = 'VEHICLE_REPORT_HISTORICAL_DATA_CSV',
    VEHICLE_UPDATE = 'VEHICLE_UPDATE',
    VEHICLE_OPEN_CAMERA_PREVIEW = 'VEHICLE_OPEN_CAMERA_PREVIEW',
    ZONE_ADD = 'ZONE_ADD',
    ZONE_REMOVE = 'ZONE_REMOVE',
    ZONE_UPDATE = 'ZONE_UPDATE',
    LOGIN = 'LOGIN'
}
